<template>
  <div>
    <header>
      <div class="logoBox">
      </div>
    </header>
    <div class="toolBox boxShadow">
      <h3>工具栏</h3>
      <div class="toolMain">
        <!-- <a href="//tzyhh.com/m/dist/#/bond"> -->
        <div class="toolBar" @click="selLink('//tzyhh.com/m/dist/#/bond')">
          <img src="../assets/bzj.png" alt="">
          <div>最新保证金</div>
        </div>
        <!-- </a> -->
        <div class="toolBar" @click="selLink('//tzyhh.com/m/dist/#/calc')">
          <!-- <a href="//tzyhh.com/m/dist/#/calc"> -->
          <img src="../assets/jsq.png" alt="">
          <div>交易计算器</div>
          <!-- </a> -->
        </div>
        <div class="toolBar" @click="selLink('//tzyhh.com/m/yinqi/#')">
          <img src="../assets/yqzz.png" alt="">
          <div>银期关联</div>
        </div>
        <div class="toolBar">
          <a href="#changjianwenti">
            <img src="../assets/cjwt.png" alt="">
            <div>常见问题</div>
          </a>
        </div>
      </div>
    </div>
    <div class="articleBox boxShadow">
      <h3>期货基础</h3>
      <div class="articleMain">
        <div class="articleBar" v-for="item in article.qihuojichu" :key="item.link" @click="selArticle(item)">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="articleBox boxShadow">
      <h3>期货交易</h3>
      <div class="articleMain">
        <div class="articleBar" v-for="item in article.qihuojiaoyi" :key="item.link" @click="selArticle(item)">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="articleBox boxShadow">
      <h3>期货品种</h3>
      <div class="articleMain">
        <div class="articleBar" v-for="item in article.qihuopinzhong" :key="item.link" @click="selArticle(item)">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="articleBox boxShadow">
      <h3>期权基础</h3>
      <div class="articleMain">
        <div class="articleBar" v-for="item in article.qiquanjichu" :key="item.link" @click="selArticle(item)">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="articleBox boxShadow">
      <h3>期权交易</h3>
      <div class="articleMain">
        <div class="articleBar" v-for="item in article.qiquanjiaoyi" :key="item.link" @click="selArticle(item)">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="articleBox boxShadow" id="changjianwenti">
      <h3>常见问题</h3>
      <div class="articleMain">
        <div class="articleBar" v-for="item in cjwtList" :key="item.link"
          @click="selLink(item.hrefOrg.replace('https://www.yhqh.com.cn/', '//www.tzyhh.com/m/changjianwenti/'))">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div id="iframeBox" v-show="openIframe">
      <iframe :src="selSrc" frameborder="0"></iframe>
      <div style="text-align: center;">
        <span @click="closeIframe" class="closeBtn">关闭</span>
      </div>
    </div>
    <div class="account">
      <img src="http://tzyhh.com/wp/wp-content/themes/yinhemobile/asset/img/gzh-tzyhh.png">
      <img src="http://tzyhh.com/wp/wp-content/themes/yinhemobile/asset/img/xcx-yhqhkh.png">
      <img src="http://tzyhh.com/wp/wp-content/themes/yinhemobile/asset/img/dy-tzyhh.png">
    </div>
    <p style="text-align: center;">
      <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备19035411号
      </a>
    </p>
  </div>
</template>

<script>
import axios from 'axios'
import article from '../data/article.json'
import cjwtList from '../data/changjianwenti.json'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      article,
      cjwtList,
      selSrc: '',
      openIframe: false
    }
  },
  created() {
    // this.getData()
  },
  methods: {
    getData() {
      // axios.get('https://www.mpxiaomi.net/menu/articles/?page=2&menuId=5353&sortId=13209').then(function () {
      axios.get('/mpxiaomi/?page=2&menuId=5353&sortId=13209').then(function () {
      })
    },
    selLink(link) {
      console.log(link)
      this.selSrc = link;
      this.openIframe = true;
    },
    closeIframe() {
      this.openIframe = false;
    },
    selArticle(item) {
      // this.selSrc = item.link;
      // this.openIframe = true;
      window.location.href = item.link;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.articleMain {
  max-height: 400px;
  overflow: auto;
}

.account {
  text-align: center;
  font-size: 0.22rem;
  color: #666666;
  letter-spacing: 0.02rem;
}

.account img {
  width: 30%;
  max-width: 200px;
  display: inline-block;
  margin: 10px;
}

#iframeBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #fff;
}

#iframeBox iframe {
  width: 100%;
  height: calc(100% - 50px);
}

#iframeBox .closeBtn {
  text-align: center;
  padding: 10px;
  cursor: pointer;
  display: inline-block;
  margin: auto;
  color: blue;
  font-weight: bold;
}


header {
  box-shadow: 0 1px 3px hsl(0deg 0% 7% / 10%);
  background: #fff;
  /* min-width: 1000px; */
  overflow: hidden;
  position: relative;
  z-index: 100;
}

.logoBox {
  width: 200px;
  height: 50px;
  margin: 5px 0;
  background: url(../assets/logo.png) no-repeat center center;
  background-size: contain;
}

.boxShadow {
  box-shadow: 0 1px 3px hsl(0deg 0% 7% / 10%);
  background: #fff;
  margin: 20px auto;
  max-width: 1000px;
  padding: 0 0 20px 0;
}

.boxShadow h3 {
  padding: 8px 12px;
  border-bottom: 1px solid #f0f2f7;
}

.articleBar {
  padding: 8px 12px;
}

.articleBar:hover {
  color: #056de8;
  cursor: pointer;
}

.toolMain {
  display: flex;
  justify-content: center;
}

.toolMain .toolBar {
  padding: 20px;
  flex: 1;
  text-align: center;
  cursor: pointer;
}

.toolMain .toolBar img {
  width: 60px;
}

a {
  text-decoration: none;
}
</style>
